import React from 'react';
import { CandlestickChart } from 'lucide-react';
import { motion } from 'framer-motion';
export function Header() {
  return <header className="w-full py-6 px-6 md:px-12 flex items-center justify-between z-50 relative" data-id="element-34">
      <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="flex items-center gap-3" data-id="element-35">
        <div className="relative flex items-center justify-center w-10 h-10 rounded-lg bg-carbon-800 border border-gold-500/30 shadow-[0_0_15px_rgba(212,175,55,0.15)]" data-id="element-36">
          <CandlestickChart className="w-5 h-5 text-gold-500" strokeWidth={1.5} data-id="element-37" />
        </div>
        <div className="flex flex-col" data-id="element-38">
          <span className="font-serif text-lg md:text-xl font-semibold tracking-wide text-gold-200 leading-none" data-id="element-39">
            DAY TRADER ORO
          </span>
          <span className="text-[10px] uppercase tracking-[0.2em] text-gold-500/70 mt-1 font-medium" data-id="element-40">
            Copy Trading
          </span>
        </div>
      </motion.div>
    </header>;
}